import axios from '@axios'

const route = 'system/booking-engine-config'

export default {
  namespaced: true,

  state: {
    config: null,
    loading: false,
  },

  getters: {
    getConfig: state => state.config,
    isLoading: state => state.loading,
    isEnabled: state => state.config?.enabled || false,
  },

  mutations: {
    SET_CONFIG(state, config) {
      state.config = config
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },

  actions: {
    /**
     * Carrega a configuração do motor de reservas
     */
    loadConfig({ commit }) {
      commit('SET_LOADING', true)

      return axios.get(route)
        .then(response => {
          if (response.data.success && response.data.data) {
            commit('SET_CONFIG', response.data.data)
          }

          return response
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },

    /**
     * Atualiza a configuração do motor de reservas
     */
    updateConfig({ commit }, config) {
      commit('SET_LOADING', true)

      return axios.post(route, config)
        .then(response => {
          if (response.data.success && response.data.data) {
            commit('SET_CONFIG', response.data.data)
          }

          return response
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },

    /**
     * Verifica apenas o status (enabled/disabled)
     */
    getStatus() {
      return axios.get(`${route}/status`)
    },

    /**
     * Reseta as configurações para os valores padrão
     */
    resetConfig({ commit }) {
      commit('SET_LOADING', true)

      return axios.post(`${route}/reset`)
        .then(response => {
          if (response.data.success && response.data.data) {
            commit('SET_CONFIG', response.data.data)
          }

          return response
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
  },
}
